import * as Yup from 'yup';

export const schema = (countExtraFields: number): any => {
	// lo hacemos de forma dinámica
	const fields: Record<string, unknown> = {};
	for (let i = 1; i <= countExtraFields; i++) {
		const key = `campo${i}`;
		fields[key] = Yup.string().nullable(true); // or assign an initial value
	}

	// generamos las validaciones por si hace falta una extra se añade aquí
	const validation: any = {
		...fields
	}

	// regresamos el schema
	return Yup.object(validation);
}
